import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";

// Stripe
import { getCheckoutUrl } from "../../config/stripe-config";

// Redux
import { connect } from 'react-redux';
  
const PriceOptions = ({
    auth: {
        isAuthenticated
    }
}) =>  {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const [monthlyProcessing, setMonthlyProcessing] = useState(false);
    const [annualProcessing, setAnnualProcessing] = useState(false);
      
    useEffect(() => {
          
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());
    
        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);
    
    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };
    
    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

    const upgradeToPremium = async (subscription_option) => {
        console.log('UPGRADING TO PREMIUM');

        if(monthlyProcessing || annualProcessing) return

        if(!isAuthenticated) {
            window.location.href = '/signup';
            return;
        }

        try {
            let priceId;
            if(subscription_option === 'annual') {
                setAnnualProcessing(true);
                priceId = 'price_1RCl2TDsLplMK070UXAP4FYb';
            } else {
                setMonthlyProcessing(true);
                priceId = 'price_1RCl12DsLplMK070ZzZ2pTLg';
            }
            const checkoutUrl = await getCheckoutUrl(priceId);
            window.location.href = checkoutUrl;
            console.log('redirected');
        } catch (error) {
            console.log('ERROR GETTING CHECKOUT LINK');
            // console.log(error)
            alert('Something Went Wrong. Please logout and try again.')
        } finally {
            setAnnualProcessing(false);
            setMonthlyProcessing(false);
        }
    }

	return (
        <div style={{display: 'grid', gridTemplateColumns: `${isMobile ? '1fr' : 'repeat(2,minmax(0,1fr))'}`, gap: '2rem', boxSizing: 'border-box'}}>
            {/* Price Box 1 */}
            <div style={{background: 'rgb(17,17,17)', padding: '2rem', flexDirection: 'column', display: 'flex', border: '1px solid #FFFF00', borderRadius: '1rem'}}>
                {/* Top Section */}
                <div style={{marginBottom: '2rem', display: 'flex', justifyContent: 'space-between'}}>
                    <div>
                        <h3 style={{fontSize: '1.5rem', fontWeight: 'bold', margin: '0'}}>
                            Monthly
                        </h3>
                        <p style={{color: 'rgb(156, 163, 175)', fontSize: '.875rem', marginTop: '.5rem'}}>
                            Billed monthly
                        </p>
                    </div>
                    <div style={{fontWeight: 'bold', fontSize: '1.875rem'}}>
                        $40
                        <span style={{color: 'rgb(156, 163, 175)', fontWeight: 500, fontSize: '.875rem', marginLeft: '.25rem'}}>/month</span>
                    </div>
                </div>
                {/* Middle Section */}
                <div style={{flexGrow: 1, marginBottom: '2rem'}}>
                    <ul style={{fontSize: '1rem', listStyle: 'none', margin: 0, padding: '0'}}>
                        <li style={{marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '.75rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '1.125rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(229,241,235)'}}>
                            Unlimited monthly usage
                            </span>
                        </li>
                        <li style={{marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '.75rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '1.125rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(229,241,235)'}}>
                            Undetectable desktop app
                            </span>
                        </li>
                        <li style={{marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '.75rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '1.125rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(229,241,235)'}}>
                            Solving and debugging
                            </span>
                        </li>
                        <li style={{marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '.75rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '1.125rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(229,241,235)'}}>
                            Most powerful AI models
                            </span>
                        </li>
                    </ul>
                </div>
                {/* Bottom Section */}
                <button 
                    onClick={() => upgradeToPremium('monthly')} 
                    style={{background: '#FFFF00', height: '2.75rem', color: '#000', fontWeight: 'bold', fontSize: '1.125rem', padding: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '.75rem', border: 'none', cursor: 'pointer'}}
                    disabled={(monthlyProcessing || annualProcessing)}
                >
                    {monthlyProcessing ? 'Processing...' : 'Subscribe'}
                </button>
            </div>
            {/* Price Box 2 */}
            <div style={{background: 'rgb(17,17,17)', padding: '2rem', flexDirection: 'column', display: 'flex', border: '1px solid #FFFF00', borderRadius: '1rem'}}>
                {/* Top Section */}
                <div style={{marginBottom: '2rem', display: 'flex', justifyContent: 'space-between'}}>
                    <div>
                        <h3 style={{fontSize: '1.5rem', fontWeight: 'bold', margin: '0'}}>
                            Annual
                        </h3>
                        <p style={{color: 'rgb(156, 163, 175)', fontSize: '.875rem', marginTop: '.5rem'}}>
                            Billed yearly
                        </p>
                    </div>
                    <div style={{fontWeight: 'bold', fontSize: '1.875rem'}}>
                        $200
                        <span style={{color: 'rgb(156, 163, 175)', fontWeight: 500, fontSize: '.875rem', marginLeft: '.25rem'}}>
                            /year
                        </span>
                    </div>
                </div>
                {/* Middle Section */}
                <div style={{flexGrow: 1, marginBottom: '2rem'}}>
                    <ul style={{fontSize: '1rem', listStyle: 'none', margin: 0, padding: '0'}}>
                        <li style={{marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '.75rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '1.125rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(229,241,235)'}}>
                            Unlimited monthly usage
                            </span>
                        </li>
                        <li style={{marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '.75rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '1.125rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(229,241,235)'}}>
                            Undetectable desktop app
                            </span>
                        </li>
                        <li style={{marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '.75rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '1.125rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(229,241,235)'}}>
                            Solving and debugging
                            </span>
                        </li>
                        <li style={{marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '.75rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '1.125rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(229,241,235)'}}>
                            Most powerful AI models
                            </span>
                        </li>
                        <li style={{marginTop: '1rem', display: 'flex', alignItems: 'center', gap: '.75rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '1.125rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(229,241,235)'}}>
                            Priority support
                            </span>
                        </li>
                    </ul>
                </div>
                {/* Bottom Section */}
                <button 
                    onClick={() => upgradeToPremium('annual')} 
                    style={{background: '#FFFF00', height: '2.75rem', color: '#000', fontWeight: 'bold', fontSize: '1.125rem', padding: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '.75rem', border: 'none', cursor: 'pointer'}}
                    disabled={(monthlyProcessing || annualProcessing)}
                >
                    {annualProcessing ? 'Processing...' : 'Subscribe'}
                </button>
            </div>
        </div>
	);
  }
  
PriceOptions.propTypes = {
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    auth: state.auth
})

export default connect(mapStateToProps, {
    
    // Connecting actions to the component

})(PriceOptions);
  